import { createPluginFactory } from '@udecode/plate';

export const MARK_COMMENT_ID = 'comment-id';

export const createCommentPlugin = createPluginFactory({
  key: MARK_COMMENT_ID,
  isLeaf: true,
});
